{
  "app": {
    "version": "Version {{version}} · Light Business Management"
  },
  "actions": {
    "label": "Actions",
    "close": "Fermer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "edit": "Modifier",
    "delete": "Supprimer",
    "done": "Terminé",
    "undo": "Annuler les changements",
    "signOut": "Se déconnecter",
    "backHome": "Retour à l'accueil"
  },
  "nav": {
    "label": "Navigation principale",
    "home": "Accueil",
    "stockInOut": "Entrées et sorties",
    "transfers": "Transferts",
    "counts": "Inventaires",
    "orders": "Commandes",
    "customers": "Clients",
    "stockLevels": "Niveaux de stock",
    "products": "Produits",
    "locations": "Emplacements",
    "reports": "Rapports",
    "activity": "Journal d'activité",
    "alerts": "Alertes",
    "company": "Entreprise",
    "configuration": "Configuration",
    "users": "Utilisateurs et rôles",
    "dataTools": "Outils de données",
    "help": "Aide et guide",
    "profile": "Mon profil",
    "menu": "Menu",
    "sections": {
      "daily": "Travail quotidien",
      "sales": "Ventes",
      "stock": "Stock",
      "followUp": "Suivi",
      "admin": "Administration",
      "purchases": "Achats"
    },
    "payments": "Paiements",
    "registers": "Caisses",
    "pos": "Caisse",
    "categories": "Catégories",
    "brands": "Marques",
    "suppliers": "Fournisseurs",
    "supplierPayments": "Paiements fournisseurs",
    "documents": "Documents",
    "promotions": "Promotions",
    "onlineStore": "Boutique en ligne",
    "stockLimits": "Limites de stock"
  },
  "time": {
    "today": "Aujourd'hui",
    "yesterday": "Hier"
  },
  "search": {
    "label": "Rechercher",
    "placeholder": "Rechercher un produit, une référence, un code-barres ou un document",
    "scan": "Scanner un code-barres",
    "scanShort": "Scanner",
    "scanHint": "Les lecteurs de codes-barres écrivent dans le champ de recherche : scannez, le résultat s'ouvre.",
    "results": "Résultats de recherche",
    "noResults": "Aucun résultat pour « {{query}} ».",
    "phaseHint": "Produits, documents, personnes et emplacements. Scannez un code-barres pour ouvrir son produit.",
    "types": {
      "user": "Personne",
      "location": "Emplacement",
      "product": "Produit",
      "document": "Document",
      "customer": "Client",
      "supplier": "Fournisseur"
    },
    "documentTypes": {
      "stockIn": "Entrée",
      "stockOut": "Sortie",
      "adjustment": "Ajustement",
      "openingStock": "Stock d'ouverture",
      "transfer": "Transfert",
      "count": "Inventaire"
    }
  },
  "locations": {
    "all": "Tous les emplacements",
    "allLower": "tous les emplacements",
    "none": "Aucun emplacement pour l'instant"
  },
  "operations": {
    "new": "Nouvelle opération",
    "receive": {
      "title": "Réceptionner",
      "text": "Marchandise arrivée d'un fournisseur ou d'une autre source"
    },
    "issue": {
      "title": "Sortir du stock",
      "text": "Une vente, une utilisation ou une consommation"
    },
    "move": {
      "title": "Déplacer",
      "text": "Transfert entre deux emplacements"
    },
    "count": {
      "title": "Inventorier",
      "text": "Comparer les rayons avec le système"
    },
    "correct": {
      "title": "Corriger le stock",
      "text": "Articles abîmés, perdus ou retrouvés"
    },
    "opening": {
      "title": "Stock d'ouverture",
      "text": "Les quantités et coûts que vous avez déjà au démarrage"
    }
  },
  "language": {
    "label": "Langue"
  },
  "roles": {
    "admin": "Administrateur",
    "manager": "Responsable",
    "storekeeper": "Magasinier",
    "cashier": "Caissier",
    "viewer": "Lecteur"
  },
  "feedback": {
    "forbiddenTitle": "Cette page n'est pas prévue pour votre rôle",
    "forbiddenText": "Votre rôle ne donne pas accès à cet espace. Demandez à un administrateur si vous en avez besoin.",
    "notFoundTitle": "Page introuvable",
    "notFoundText": "L'adresse est peut-être erronée, ou la page a été déplacée."
  },
  "breadcrumb": "Fil d'Ariane",
  "pagination": {
    "label": "Pages",
    "previous": "Page précédente",
    "next": "Page suivante",
    "pageSize": "Lignes par page",
    "perPage_one": "{{count}} par page",
    "perPage_many": "{{count}} par page",
    "perPage_other": "{{count}} par page"
  },
  "locationTypes": {
    "warehouse": "Entrepôt",
    "store": "Magasin",
    "depot": "Dépôt",
    "zone": "Zone",
    "shelf": "Étagère",
    "bin": "Casier",
    "transit": "En transit"
  },
  "attachments": {
    "title": "Pièces jointes",
    "subtitle": "PDF ou images, jusqu'à {{size}} chacun.",
    "emptyReadOnly": "Aucun fichier joint.",
    "saveFirst": "Les fichiers peuvent être joints une fois le brouillon enregistré.",
    "drop": "Déposez des fichiers ici, ou",
    "choose": "Choisir des fichiers",
    "photo": "Prendre une photo",
    "uploading": "Envoi de {{name}}...",
    "open": "Ouvrir {{name}}",
    "removeOne": "Retirer {{name}}",
    "remove": "Retirer",
    "removeTitle": "Retirer {{name}} ?",
    "removeText": "Le fichier est retiré pour tout le monde. Le journal d'activité en garde la trace.",
    "removed": "Fichier retiré",
    "tooLarge": "{{name}} dépasse {{size}}.",
    "wrongType": "{{name}} n'est ni un PDF ni une image (JPEG, PNG, WebP).",
    "emptyOperation": "Aucun fichier joint : une facture, un bon de livraison, une photo...",
    "emptyProduct": "Aucun fichier joint : une fiche technique, un certificat, une photo...",
    "kb": "{{value}} Ko",
    "mb": "{{value}} Mo",
    "emptySupplierPayment": "Aucun fichier joint pour l’instant : un reçu, un avis de virement, la photo du chèque..."
  },
  "commerce": {
    "percent": "{{value}} %",
    "priceSplit": "HT {{net}} · TVA {{rate}} {{tax}} TND",
    "channelTypes": {
      "pos": "Comptoir",
      "online": "En ligne",
      "backOffice": "Back-office"
    },
    "paymentMethods": {
      "cash": "Espèces",
      "card": "Carte",
      "cheque": "Chèque",
      "transfer": "Virement",
      "cashOnDelivery": "Paiement à la livraison",
      "payAtPickup": "Paiement au retrait",
      "online": "Paiement en ligne"
    },
    "deliveryModes": {
      "shipping": "Livraison",
      "pickup": "Retrait"
    },
    "steps": {
      "picking": "Prélèvement",
      "packing": "Emballage"
    }
  },
  "maintenance": {
    "title": "Restauration des données en cours",
    "text": "L'application est fermée un instant pendant qu'une sauvegarde est rétablie. Elle rouvre d'elle-même ; reconnectez-vous ensuite.",
    "waiting": "Veuillez patienter...",
    "steps": {
      "checking": "Vérification de la sauvegarde...",
      "safety": "Mise à l'abri des données actuelles...",
      "database": "Rétablissement des données...",
      "files": "Rétablissement des fichiers...",
      "finishing": "Finalisation..."
    }
  },
  "help": {
    "print": "Imprimer",
    "contents": "Sommaire"
  }
}
